import React, {useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';

import './styles.scss';
import {
  AppForm,
  AppFormField,
  AppFormSubmitButton,
} from '../../../components/forms';
import {addToWizard} from '../../../store/actions';
import * as Yup from 'yup';
import {strings} from '../../../util/strings';
import {Column, Row} from '../../../components/layout';
import Header2 from '../../../components/headers/header2';
import {post} from '../../../api/api';
import {uriRequestActivationCode} from '../../../api/endpoints';
import {useHistory} from 'react-router-dom';
import {Icons} from '../../../util/icons';
import colors from '../../../util/colors';
import NewErrorMessage from '../../../components/new-error-message';
import EnterCodeCMD from '../activate-registration-cmd/EnterCodeCMD';
import * as fonts from '../../../util/fonts';
import moment from 'moment';

export interface DataValidationCMDProps {
  wizard: any;
  addToWizard(value: any): any;
  labels: typeof strings.pt.registoCMD;
  messageLabels: typeof strings.pt.messages;
  language: string;
}

function AccountDataCMD({
  wizard,
  labels,
  messageLabels,
  addToWizard,
  language,
}: DataValidationCMDProps) {
  const [submitting, setSubmitting] = useState(false);
  const [valid, setValid] = useState(false);
  const [formikContext, setFormikContext] = useState();
  const history = useHistory();
  const [visible, setVisible] = useState(false);
  const [viewPassword, setViewPassword] = useState(false);
  const [viewRepeatPassword, setViewRepeatPassword] = useState(false);
  const [typeOfError, setTypeOfError] = useState<any>();
  const [currentFormValues, setCurrentFormValues] = useState<any>({
    name: '',
    email: '',
    password: '',
    repeatPassword: '',
  });
  const [guid, setGuid] = useState(
    (wizard &&
      wizard.activateRegistration &&
      wizard.activateRegistration.guid) ||
      wizard?.dataValidation?.currentUser?.sessionId ||
      wizard?.sessionId ||
      ''
  );

  const handlePasswordIconClick = (repeat: boolean) => {
    if (repeat) {
      setViewRepeatPassword(!viewRepeatPassword);
    } else {
      setViewPassword(!viewPassword);
    }
  };

  const featureName = 'Register-AccountDataCMD';

  const expression =
    /^[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  const isEmailAllowed = (email: any) => {
    return expression.test(String(email).toLowerCase());
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required(messageLabels?.requiredField)
      .min(3, labels?.registoCMD_nameValidationError)
      .max(50, labels?.registoCMD_nameValidationError)
      .matches(
        new RegExp('^(?![\\s\\S]{51,})([^0-9\\s]+(?:\\s[^0-9\\s]+){1,9})$'),
        labels?.registoCMD_nameValidationError
      ),
    email: Yup.string()
      .required(messageLabels?.requiredField)
      .email(messageLabels?.invalidEmailFormat)
      .test(
        'email-format-invalid',
        labels?.registoCMD_emailPassword_emailError,
        (value) => isEmailAllowed(value)
      ),
    password: Yup.string()
      .required(messageLabels?.requiredField)
      .matches(
        new RegExp(
          '^(?!.* )(?=.*\\d)(?=.*[A-Z])(?=.*[!@#$%^&*()_+\\-=\\[\\]{};\':"\\\\|,.<>\\/?]).{12,}'
        ),
        labels?.registoCMD_emailAndPassword_passwordError
      )
      .label(''),
    repeatPassword: Yup.string()
      .required(messageLabels?.requiredField)
      .oneOf([Yup.ref('password')], messageLabels?.passwordsDontMatch),
  });

  if (!!!wizard.insuranceValidation) {
    history.push('/');
  }

  const existingEmail = wizard?.dataValidation?.currentUser?.email || '';

  switch (visible) {
    case false:
      return (
        <Column className="account-data-container-cmd">
          <AppForm
            initialValues={{
              name: '',
              email: existingEmail,
              password: '',
              repeatPassword: '',
            }}
            validateOnChange={false}
            validateOnBlur={false}
            onChange={(values: any) => {
              if (values.name !== currentFormValues.name) {
                setCurrentFormValues({
                  ...currentFormValues,
                  name: values.name,
                });
              }
              if (values.email !== currentFormValues.email)
                setCurrentFormValues({
                  ...currentFormValues,
                  email: values.email,
                });

              if (values.password !== currentFormValues.password)
                setCurrentFormValues({
                  ...currentFormValues,
                  password: values.password,
                });

              if (values.repeatPassword !== currentFormValues.repeatPassword)
                setCurrentFormValues({
                  ...currentFormValues,
                  repeatPassword: values.repeatPassword,
                });
            }}
            validationSchema={validationSchema}
            onSubmit={async (values: any, {validateForm}: any) => {
              const errors = await validateForm(values);
              if (Object.keys(errors).length > 0) {
                return;
              }
              setSubmitting(true);

              let buId: string | null = '';
              let memId: string | null = '';

              const state: string = wizard?.dataValidation?.state || null;

              const phoneNumber = '';

              const guid =
                wizard?.dataValidation?.currentUser?.sessionId ||
                wizard?.activateRegistration?.guid ||
                wizard?.sessionId ||
                '';

              const user = {
                userName: values.email,
                password: values.password,
                fullName: values.name,
                email: values.email,
                phoneNumber: phoneNumber,
                registerType: 'CMD',
                nif: wizard?.insuranceValidation?.nif,
                doB: moment(
                  wizard?.insuranceValidation?.dateOfBirth,
                  labels?.registoCMD_dateFormat
                ).format('YYYY-MM-DD'),
                cc: '',
                activationId: guid,
                sessionId: guid,
                buId: buId,
                state: !!state ? state : null,
                memId: memId,
                language: language,
                useSessionEmail: false,
              };

              const newSelectedContact = values.email;
              const newSelectedContactType = 'EMAIL';

              addToWizard({user});
              addToWizard({
                dataValidation: {
                  ...wizard?.dataValidation,
                  selectedContact: newSelectedContact,
                  selectedContactType: newSelectedContactType,
                },
              });

              try {
                await post(
                  uriRequestActivationCode(),
                  JSON.stringify({
                    destination: newSelectedContact,
                    senderType: newSelectedContactType,
                    sessionId: guid,
                    name: currentFormValues.name,
                    nif: wizard?.insuranceValidation?.nif,
                  }),
                  false,
                  featureName
                );

                addToWizard({activateRegistration: {guid}});
                setGuid(guid);
                setVisible(true);
              } catch (e: any) {
                if (e.status === 404) {
                  (formikContext as any).setFieldError(
                    'email',
                    labels?.registoCMD_emailPassword_existingUsername
                  );
                  setTypeOfError(e);
                }
              }

              setSubmitting(false);
            }}>
            <Header2 className="enter-code-header">
              {labels?.registoCMD_registerScreenSubtitle}
            </Header2>
            <Row className="account-data-row" style={{position: 'relative'}}>
              <AppFormField
                showErrorMessage
                name="name"
                placeholder={labels?.registoCMD_registerFullNamePlaceholder}
                handleFormikContext={(formik) => {
                  if (
                    !!!formikContext ||
                    formik.errors !== (formikContext as any).errors
                  ) {
                    setFormikContext(formik);
                  }
                }}
              />
            </Row>
            <Row
              className="account-data-row-email"
              style={{position: 'relative'}}>
              <AppFormField
                showErrorMessage
                handleFormikContext={setFormikContext}
                name="email"
                placeholder={
                  labels?.registoCMD_emailAndPassword_emailPlaceholder
                }
                className="account-data-input-email"
              />
            </Row>
            <Row>
              {!!typeOfError && typeOfError.status === 404 && (
                <span
                  style={{...fonts.M, color: colors.alertRed}}
                  className="email-taken-error">
                  {labels?.registoCMD_usernameAlreadyRegistered}
                </span>
              )}
            </Row>
            <hr className="account-data-hr" />
            <Row className="account-data-row" style={{position: 'relative'}}>
              <AppFormField
                showErrorMessage
                name="password"
                type={viewPassword ? 'text' : 'password'}
                passwordIcon
                showPassword={viewPassword}
                handlePasswordIconClick={() => handlePasswordIconClick(false)}
                placeholder={
                  labels?.registoCMD_emailAndPassword_passwordPlaceholder
                }
              />
            </Row>
            <Row className="account-data-row" style={{position: 'relative'}}>
              <AppFormField
                showErrorMessage
                name="repeatPassword"
                type={viewRepeatPassword ? 'text' : 'password'}
                passwordIcon
                showPassword={viewRepeatPassword}
                handlePasswordIconClick={() => handlePasswordIconClick(true)}
                placeholder={
                  labels?.registoCMD_emailAndPassword_confirmPasswordPlaceholder
                }
              />
            </Row>
            {/* <Row className="app-center">
              <ErrorMessage visible error={submitError} />
            </Row> */}

            {!!typeOfError && typeOfError.status !== 404 && (
              <NewErrorMessage
                iconName={Icons.ALERT_PROBLEM}
                colorIcon={colors.alertRed}
                text={messageLabels.general_errorMessage}></NewErrorMessage>
            )}
            <Row className="app-center">
              <AppFormSubmitButton
                title={labels?.registoCMD_registerScreenButton}
                disabled={submitting}
                className="stepper-continue-button account-data-continue-button"
              />
            </Row>
          </AppForm>
        </Column>
      );
    case true:
      return <EnterCodeCMD setValid={setValid} valid={valid} />;
  }
}

const mapStateToProps = ({wizard, strings}: any) => ({
  wizard: wizard.value,
  labels: strings.value.pt.registoCMD,
  messageLabels: strings.value.pt.messages,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(AccountDataCMD)
);
